import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StringUtils from '../../../util/stringUtils';
import localize from '../../../util/localizeUtils';
import { Container } from '../../../styled-components/Layout';
import { Input, Button } from '../../../styled-components/';

import DraggablePopup from '../../DraggablePopup';

const PromptContainer = styled(Container)`
  margin: 0.5rem;
`;

const ButtonContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const DialogButton = styled(Button)`
  margin-left: 0.5rem;
`;

const ContentContainer = styled.div`
  width: 100%;
  height: auto;
`;

class FolderPrompt extends Component {
  constructor() {
    super();

    this.state = {
      folderName: '',
      error: null
    };
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (!this.props.visible && nextProps.visible) {
      this.setState({ folderName: '', error: null });
      if (this.input) {
        this.input.addEventListener('keyup', this.keyUpEventHandler);
      }
    } else if (this.props.visible && !nextProps.visible && this.input) {
      this.input.removeEventListener('keyup', this.keyUpEventHandler);
    }
  }

  componentWillUnmount() {
    if (this.input) {
      this.input.removeEventListener('keyup', this.keyUpEventHandler);
    }
  }

  onInputChange = e => {
    this.setState({ folderName: e.target.value, error: null });
  };

  handleClick = () => {
    const { folderName } = this.state;
    if (!this.isValidFolderName(folderName)) {
      this.setState({ error: localize('requiredFolderNameError') });
    }

    this.props.onClick(folderName.trim());
    this.props.onClose();
  };

  keyUpEventHandler = event => {
    if (event.keyCode === 13) {
      event.preventDefault();
      this.handleClick();
    }
  };

  isValidFolderName = name => !!name && !!name.trim();

  renderAddRename = () => {
    const text =
      this.props.operation === 'rename'
        ? localize('saveItemFolderRenameLabelFormat').replace('{folderName}', this.props.folderName)
        : localize('saveItemFolderLabel');
    return (
      <ContentContainer>
        <label htmlFor="folderPromptInput">{text}</label>
        <Input
          ref={r => (this.input = r)}
          onChange={this.onInputChange}
          value={this.state.folderName}
          id="folderPromptInput"
          width="100%"
          placeholder={localize('folderNamePlaceholder')}
        />
      </ContentContainer>
    );
  };

  renderDelete = () => (
    <ContentContainer>
      <span>{localize('confirmDeleteFolderFormat').replace('{folderName}', this.props.folderName)}</span>
    </ContentContainer>
  );

  render() {
    const { operation, visible, onClose } = this.props;
    return (
      <DraggablePopup
        title={localize('folderOperationTitleFormat').replace('{operation}', StringUtils.capitalize(operation))}
        closeDialog={this.props.onClose}
        defaultPosition={{ x: 50, y: 50 }}
        axis="none"
        height={7 * parseFloat(getComputedStyle(document.documentElement).fontSize)}
        z-index={100}
        handle=".handle"
        visible={visible}
      >
        <PromptContainer>
          {operation === 'delete' ? this.renderDelete() : this.renderAddRename()}
          <ButtonContainer>
            <DialogButton onClick={this.handleClick}>
              {operation === 'delete' ? localize('okButton') : localize('submitButton')}
            </DialogButton>
            <DialogButton onClick={onClose}>{localize('cancelButton')}</DialogButton>
          </ButtonContainer>
        </PromptContainer>
      </DraggablePopup>
    );
  }
}

FolderPrompt.defaultProps = {
  visible: false,
  folderName: ''
};

FolderPrompt.propTypes = {
  operation: PropTypes.oneOf(['add', 'rename', 'delete']).isRequired,
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  folderName: PropTypes.string
};

export default FolderPrompt;



// WEBPACK FOOTER //
// ./app/components/SavedItems/FolderTree/FolderPrompt.js